// extracted by mini-css-extract-plugin
export var cardrelated = "card-module--cardrelated--3bf4d";
export var numberTotal = "card-module--numberTotal--04500";
export var results = "card-module--results--b8b83";
export var tagsblock = "card-module--tagsblock--d5015";
export var time = "card-module--time--3bb99";